import React, { Fragment, useState } from 'react';
import { Button, Card, Modal, Upload, message } from 'antd';
import { ExportOutlined, DeleteOutlined } from '@ant-design/icons';
import Axios from 'axios';
import { url } from '../../config/global';

const UploadSPStockSupplier = ({ isVisible, closeModal, getData, setFailedData, setFailedModal }) => {
  const [data, setData] = useState({ file: null });
  const [loading, setLoading] = useState(false);

  const handleRemove = () => {
    setData({ file: null });
  };

  const handleBeforeUpload = (file) => {
    setData({ file });
    return false;
  };

  const onSaveData = () => {
    setLoading(true);
    const fd = new FormData();
    fd.append('file', data.file);

    Axios.post(`${url}/stock-inventory/import`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    })
      .then((res) => {
        const { total_success, total_failed, message: msg, failed } = res.data;
        if (total_success > 0 && total_failed > 0) {
          message.success(msg);
          setFailedData(failed);
          setFailedModal(true);
          getData();
        } else if (total_success > 0) {
          message.success(msg);
          closeModal();
          getData();
        } else if (total_failed > 0) {
          message.warning(msg);
          setFailedData(failed);
          setFailedModal(true);
        }
      })
      .catch((err) => {
        if (err.response) {
          const errorsKey = Object.keys(err.response.data.errors || {});
          const errors = err.response.data.errors || {};
          message.open({
            message: `Error!: ${err.response.data.message}`,
            description: (
              <div>
                Error Details:
                {errorsKey.map((error) => (
                  <div key={error}>{errors[error][0]}</div>
                ))}
              </div>
            ),
          });
          if (err.response.status === 401) {
            sessionStorage.removeItem('token');
          }
        } else {
          message.error('Backend not yet Started');
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
        setData({ file: null });
      });
  };

  return (
    <Modal
      title="Import Data Adjust Stock Inventory"
      visible={isVisible}
      footer={[
        <Button key="close" onClick={closeModal}>
          Close
        </Button>,
        <Button key="upload" loading={loading} onClick={onSaveData} type="primary" htmlType="submit" disabled={!data.file}>
          Upload
        </Button>,
      ]}
      onCancel={closeModal}
    >
      <Card>
        <div>
          <div style={{ marginBottom: '8px', fontWeight: '500' }}>File</div>
          <Upload onRemove={handleRemove} beforeUpload={handleBeforeUpload} fileList={[]}>
            <Button style={{ width: '420px' }}>
              <ExportOutlined /> No file choosen
            </Button>
          </Upload>
          {data.file && (
            <Fragment>
              <Button onClick={handleRemove} type="danger" ghost style={{ marginTop: '8px', marginRight: '8px' }}>
                <DeleteOutlined />
              </Button>
              {data.file.name ? data.file.name : data.file}
            </Fragment>
          )}
        </div>
      </Card>
    </Modal>
  );
};

export default UploadSPStockSupplier;
